<template>
	<div
		class="ms-input flex ms-editor"
		:class="{ isValid: errorProvider.isValid, 'input-disabled': disabled }"
	>
		<textarea
			class="ms-input-item pb-2 pt-2"
			:placeholder="placeholder"
			v-model="internalText"
			:disabled="disabled"
			ref="input"
			v-on="listeners"
			:maxLength="maxLength"
			:style="textareaStyle"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: 'error',
			}"
			v-if="errorProvider.isValid"
		>
			<div class="mi mi-24 mi-red-tick"></div>
		</div>
		<div :class="['icon-input', 'mi', 'mi-18', icon]" v-if="icon"></div>
	</div>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'MsTextarea',
	props: {
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: null,
		},
		/**
		 * Hiện thị chũ mờ ở dưới ô input
		 * Created by LTDAT(22.06.2020)
		 */
		placeholder: {
			default: null,
			type: [Number, String],
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		//Giới hạn nhập của ô input
		maxLength: {
			default: null,
			type: Number,
		},
		height: ''
	},
	data() {
		return {
			internalText: this.value,
			focused: false,
		};
	},
	computed: {
		listeners() {
			return {
				blur: (e) => {
					this.onBlur(e);
				},
				focus: (e) => {
					this.onFocus(e);
				},
				change: (e) => {
					this.validate(this.internalText);
					this.$emit('change', this.internalText, e);
				},
				keydown: (e) => {
					this.$emit('keydown', e);
				},
				input: (e) => {
					this.$emit('input', e);
				},
			};
		},
		//Style động cho textarea, tự thêm px nếu height chỉ là số
		textareaStyle() {
			const me = this;
			if (!me.height) return {};
			return {
				height: /^\d+$/.test(me.height) ? `${me.height}px` : me.height,
			};
		},
	},
	methods: {
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
		},
		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			me.internalText = value;
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				//hvanh - 14.6.2024 fixbug 374701 - Khi paste dữ liệu lơn hơn maxLength thì nexVal là 1 InputEvent 
				if (newVal instanceof InputEvent) {
					newVal = oldVal;
				}
				me.validate(newVal);
				me.$emit('input', newVal);
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setValue(newVal);
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInput.scss';
	.ms-input-item {
		line-height: 16px;
	}
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInput.scss';
	.ms-input-item {
		line-height: 16px;
	}
}
::-webkit-input-placeholder {
	font-style: italic;
}
:-moz-placeholder {
	font-style: italic;
}
::-moz-placeholder {
	font-style: italic;
}
:-ms-input-placeholder {
	font-style: italic;
}
</style>

